import { render, staticRenderFns } from "./BurchaseSurvey.vue?vue&type=template&id=2cdc8d5a&"
import script from "./BurchaseSurvey.vue?vue&type=script&lang=js&"
export * from "./BurchaseSurvey.vue?vue&type=script&lang=js&"
import style0 from "./BurchaseSurvey.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports